import { Info } from "lucide-react";

// Default notices (CMS-editable in a later phase). Texts pending legal review.
export const NOTICES = {
  general:
    "2Voto es una plataforma ciudadana independiente de información, consultas y propuestas. No representa a partidos, candidatos, gobiernos ni autoridades electorales.",
  resultados:
    "Los resultados reflejan las respuestas válidas de quienes participaron voluntariamente durante el periodo indicado. No representan necesariamente a toda la población ni constituyen una elección oficial.",
  propuestas:
    "La publicación de una propuesta ciudadana no implica respaldo institucional de 2Voto ni constituye legislación oficial o asesoramiento jurídico.",
  legal:
    "El contenido de 2Voto es informativo y participativo. No constituye asesoramiento jurídico, electoral, financiero ni gubernamental.",
  confidencialidad:
    "Las respuestas no se muestran públicamente asociadas con la identidad del participante. La plataforma aplica controles de confidencialidad, seguridad y minimización de datos, sujetos a obligaciones legales válidas.",
  leyes:
    "Las ideas sobre leyes o enmiendas son propuestas ciudadanas para discusión pública y no constituyen legislación oficial ni interpretación jurídica autorizada.",
};

const TONE = {
  neutral: "bg-slate-100 border-slate-200 text-slate-600",
  info: "bg-cyan-50 border-cyan-200 text-cyan-800",
  amber: "bg-amber-50 border-amber-200 text-amber-800",
};

export function Notice({ variant = "general", tone = "neutral", className = "" }) {
  const text = NOTICES[variant] || NOTICES.general;
  return (
    <div
      data-testid={`notice-${variant}`}
      className={`rounded-lg border p-4 text-sm flex items-start gap-3 leading-relaxed ${TONE[tone]} ${className}`}
    >
      <Info className="w-4 h-4 shrink-0 mt-0.5" />
      <p>{text}</p>
    </div>
  );
}
